import { Alert, Box, CircularProgress, Typography } from '@mui/material';
import { useLocation, useParams } from 'react-router-dom';

import Flex from '@Components/Bases/Flex';
import OtherExplanations from '@Containers/OtherExplanations';
import { useGetGoalsAndOperationalPlans } from '@Domains/GoalsAndOperationalPlans';
import { useEffect } from 'react';
import GoalAndOperationalPlansCompletionCheckbox from './Components/GoalAndOperationalPlansCompletionCheckbox/GoalAndOperationalPlansCompletionCheckbox';
import GoalAndOperationalPlansDetail from './Containers/GoalAndOperationalPlansDetail';
import GoalAndOperationalPlansFormProvider from './Containers/GoalAndOperationalPlansFormProvider';
import GoalAndOperationalPlansOverview from './Containers/GoalAndOperationalPlansOverview';
import GoalsAndOperationalPlansFooter from './Containers/GoalsAndOperationalPlansFooter';
import { mapGoalsAndOperationalPlansToFormValues } from './utils';

const GoalAndOperationalPlans = () => {
  const { id } = useParams();
  const location = useLocation();
  const currentPath = location.pathname.split('/').pop();

  const [{ data, loading, error }, refetch] =
    useGetGoalsAndOperationalPlans(id);

  const initialValues = mapGoalsAndOperationalPlansToFormValues(data);

  useEffect(() => {
    if (currentPath === 'goals-and-operational-plans') {
      refetch().catch((err) => {
        if (err.name !== 'CanceledError') {
          console.error('Failed to fetch goals and operational plans :', err);
        }
      });
    }
  }, [currentPath, refetch]);

  if (loading) {
    return (
      <Flex justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress size={50} />
      </Flex>
    );
  }

  if (error) {
    return (
      <Box p={2}>
        <Alert severity={'error'}>
          ไม่สามารถโหลดข้อมูลแผนการเพิ่มมูลค่าองค์กร และการบริหารความเสี่ยงได้
        </Alert>
      </Box>
    );
  }

  return (
    <GoalAndOperationalPlansFormProvider initialValues={initialValues}>
      <Flex flexDirection={'column'} gap={2} p={2} mb={8}>
        <Typography variant="h3">
          ส่วนที่ 2 แผนการเพิ่มมูลค่าองค์กร และการบริหารความเสี่ยง
        </Typography>
        <GoalAndOperationalPlansOverview />
        <GoalAndOperationalPlansDetail />
        <OtherExplanations />
        <GoalAndOperationalPlansCompletionCheckbox />
      </Flex>
      <GoalsAndOperationalPlansFooter />
    </GoalAndOperationalPlansFormProvider>
  );
};

export default GoalAndOperationalPlans;
